module.exports = __webpack_public_path__ + "img/05.7d7bb748.png";